'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AudioManager = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioManager = exports.AudioManager = function () {
    function AudioManager(audio) {
        (0, _classCallCheck3.default)(this, AudioManager);

        this.lastPlayed = 0;
        this.audio = audio;
    }

    (0, _createClass3.default)(AudioManager, [{
        key: 'play',
        value: function play() {
            if (!this.lastPlayed || Date.now() - this.lastPlayed > 2000) {
                this.audio.play();
                this.lastPlayed = Date.now();
            }
        }
    }, {
        key: 'listen',
        value: function listen(state) {
            var _this = this;

            state.$on('audio.bleep', function () {
                _this.play();
            });
        }
    }, {
        key: 'watchForMessages',
        value: function watchForMessages(state) {
            var _this2 = this;

            state.$on('message.new', function (message, buffer) {
                if (buffer.setting('mute_sound')) {
                    return;
                }

                var ignoreTypes = ['connection', 'traffic', 'mode', 'nick'];
                if (ignoreTypes.indexOf(message.type) > -1) {
                    return;
                }

                if (message.ignore || buffer.isSpecial()) {
                    return;
                }

                var shouldBleep = buffer.getNetwork().nick !== message.nick && (message.isHighlight && buffer.setting('alert_on') === 'highlight' || buffer.setting('alert_on') === 'message');
                var isActiveBuffer = state.getActiveBuffer() === buffer;
                var inFocus = isActiveBuffer && state.ui.app_has_focus;

                if (shouldBleep || buffer.isQuery() && !inFocus) {
                    _this2.play();
                }
            });
        }
    }]);
    return AudioManager;
}();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["AudioManager"]
window._kiwi_exports.libs.AudioManager = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/AudioManager.js
// module id = b30k
// module chunks = 1